// Angular Files
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Angular Material Files
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';

// Module Files
import { HeaderComponent } from './components/header/header.component';

// Teller Online Files
import { SharedModule } from 'apps/admin-portal/src/app/shared/shared.module';

// Teller Online Library Files
import { TellerOnlineHelpModule, HelpServiceBase } from 'teller-online-libraries/help';
import { ConfigHelpService } from 'apps/admin-portal/src/app/features/config/services/config-help.service';

// API Clients
import {
    AuthApiClient,
    AdminPaymentsApiClient,
    AdminScheduledPaymentsApiClient,
    AdminUsersApiClient,
    UserApiClient,
    ConfigurationApiClient,
    AuthorizationTextApiClient
} from 'apps/admin-portal/src/app/core/api/AdminPortalApiClients';

@NgModule({
    imports: [
        CommonModule,
        RouterModule, // Used by the NavMenuComponent
        SharedModule,
        TellerOnlineHelpModule,
        MatToolbarModule,
        MatIconModule,
        MatLegacyMenuModule,
        MatLegacyButtonModule,
        MatLegacyTooltipModule
    ],
    declarations: [HeaderComponent],
    exports: [HeaderComponent],
    providers: [
        AuthApiClient,
        AdminPaymentsApiClient,
        AdminScheduledPaymentsApiClient,
        AdminUsersApiClient,
        UserApiClient,
        ConfigurationApiClient,
        AuthorizationTextApiClient,
        { provide: HelpServiceBase, useExisting: ConfigHelpService }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
 }